import { grpc } from "@improbable-eng/grpc-web";
import { UnaryOutput } from "@improbable-eng/grpc-web/dist/typings/unary";
import { ProtobufMessage } from "@improbable-eng/grpc-web/dist/typings/message";

import AuthUtils from "@/utils/auth-utils";

import { Admin as Service } from "@/proto/admin/all_pb_service";
import * as ServiceProto from "@/proto/admin/all_pb";

import { KYCStatusMap } from "@/proto/identity/identity/all_pb";

export default class KYCService {
  constructor(private baseURL: string, private token: string) {}

  public async updateKycStatus(
    orgId: string,
    kycStatus: KYCStatusMap[keyof KYCStatusMap]
  ): Promise<void> {
    const request = new ServiceProto.UpdateKYCStatusRequest();

    request.setOrgid(orgId);
    request.setKycstatus(kycStatus);

    const { status, statusMessage }: UnaryOutput<ProtobufMessage> =
      await new Promise((resolve) => {
        grpc.unary(Service.UpdateKYCStatus, {
          request,
          host: this.baseURL,
          onEnd: resolve,
          metadata: AuthUtils.getMetadata(this.token),
        });
      });

    if (status !== grpc.Code.OK) {
      throw new Error(
        `Error with updateKycStatus: code=${status} msg=${statusMessage}`
      );
    }
  }

  public async rejectKYCApplication(orgId: string): Promise<boolean> {
    const request = new ServiceProto.RejectKYCApplicationRequest();

    request.setOrgid(orgId);

    const { status, statusMessage }: UnaryOutput<ProtobufMessage> =
      await new Promise((resolve) => {
        grpc.unary(Service.RejectKYCApplication, {
          request,
          host: this.baseURL,
          onEnd: resolve,
          metadata: AuthUtils.getMetadata(this.token),
        });
      });

    if (status !== grpc.Code.OK) {
      throw new Error(
        `Error with RejectKYCApplication: code=${status} msg=${statusMessage}`
      );
    }

    return true;
  }
}
